import React from 'react';
import classNames from 'classnames';

function CtaButtonContainer({ className, align = 'left', children, fullWidthMobile, fullWidth }) {
  return (
    <div
      className={classNames(
        'cta-button-component-container',
        `cta-button-component-container-${align}`,
        fullWidthMobile && 'container-full-width-mobile',
        fullWidth && 'container-full-width',
        className
      )}
    >
      {children}
    </div>
  );
}

export default CtaButtonContainer;



// WEBPACK FOOTER //
// ./src/components/elements/CtaButton/CtaButtonContainer.js